<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <label for="{{controlId}}" class="control-label" *ngIf="showLabel">
      <span *ngIf="!label" i18n="@@animalGender">Gender</span>
      <span *ngIf="label">{{label}}</span>&nbsp;<span *ngIf="showRequired && required">*</span>
    </label>

    <select id="{{controlId}}" class="form-control" [formControlName]="controlName" [class.is-invalid]="showInvalid"
            [class.is-valid]="showValid" (keypress)="keypress($event)" (change)="onChange($event)">
      <option [value]="null" disabled selected i18n="@@animalGender">Gender</option>
      <option *ngFor="let d of data" [value]="d?.id">{{d?.tag}}</option>
    </select>

    <div *ngIf="showInvalid" class="invalid-feedback">
      <div *ngIf="control?.hasError('required')" i18n="@@requiredInput">This input is required.</div>
    </div>
  </div>
</div>
